exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skill .contents .content[data-v-1332f337]{width:370px;margin:auto;text-align:center;padding:0 20px}.skill .contents .content>div[data-v-1332f337]:nth-child(2n){float:right}.skill .contents .content>div[data-v-1332f337]:nth-child(odd){float:left}.skill .contents .content>div[data-v-1332f337]{position:relative;margin-top:30px}.skill .contents .content>div h3[data-v-1332f337]{font:700 1.7rem/19px Ubuntu,sans-serif;margin-bottom:17px}.skill .contents .content>div strong[data-v-1332f337]{display:inline-block;position:absolute;right:43px;top:53px;font:700 2rem/24px Lato,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1332f337","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/skill.vue
// module id = 54
// module chunks = 0